/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailPreviewDto
 */
export interface EmailPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    emailType: EmailPreviewDtoEmailTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailPreviewDto
     */
    htmlContent: string;
}


/**
 * @export
 */
export const EmailPreviewDtoEmailTypeEnum = {
    SalesInvoiceToContractor: 'SalesInvoiceToContractor',
    SalesInvoiceDuplicateToContractor: 'SalesInvoiceDuplicateToContractor',
    SurveyToClient: 'SurveyToClient',
    ExcelImport: 'ExcelImport',
    Applications: 'Applications',
    PositionAppForeign: 'PositionAppForeign',
    ApplicationExecutions: 'ApplicationExecutions',
    Orders: 'Orders',
    OrdersRemind: 'OrdersRemind',
    OrderExecutions: 'OrderExecutions',
    OrderExecutionsRemind: 'OrderExecutionsRemind',
    UnblockEstimateByMonth: 'UnblockEstimateByMonth',
    PurchaserCreatedInOrder: 'PurchaserCreatedInOrder',
    PurchaserEditedInOrder: 'PurchaserEditedInOrder',
    TooManyPurchasersInOrder: 'TooManyPurchasersInOrder',
    ProjectDelayed: 'ProjectDelayed',
    ProjectToCancel: 'ProjectToCancel',
    ProjectDateChange: 'ProjectDateChange',
    PurchaseDeficiencies: 'PurchaseDeficiencies',
    SalesInvoicing: 'SalesInvoicing',
    SpecialInvoicing: 'SpecialInvoicing',
    ContractImportError: 'ContractImportError',
    ContractsWaitingToSign: 'ContractsWaitingToSign',
    SignedContracts: 'SignedContracts',
    ContractSignedNotSent: 'ContractSignedNotSent',
    ContractUnsigned: 'ContractUnsigned',
    CyclicJobError: 'CyclicJobError',
    FvzTeamReminder: 'FVZTeamReminder',
    NoPurchaserInOrder: 'NoPurchaserInOrder',
    MirrorProject: 'MirrorProject',
    MirrorProjectError: 'MirrorProjectError'
} as const;
export type EmailPreviewDtoEmailTypeEnum = typeof EmailPreviewDtoEmailTypeEnum[keyof typeof EmailPreviewDtoEmailTypeEnum];


/**
 * Check if a given object implements the EmailPreviewDto interface.
 */
export function instanceOfEmailPreviewDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "emailType" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "htmlContent" in value;

    return isInstance;
}

export function EmailPreviewDtoFromJSON(json: any): EmailPreviewDto {
    return EmailPreviewDtoFromJSONTyped(json, false);
}

export function EmailPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPreviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'emailType': json['emailType'],
        'subject': json['subject'],
        'htmlContent': json['htmlContent'],
    };
}

export function EmailPreviewDtoToJSON(value?: EmailPreviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'emailType': value.emailType,
        'subject': value.subject,
        'htmlContent': value.htmlContent,
    };
}

